<div
  class="flex flex-col w-full"
  [ngClass]="{
    'space-y-0': compactMode,
    'space-y-4': !compactMode
  }"
>
  <div
    class="relative w-full flex-shrink-0 p-4 rounded-10 border-1 border-dashed flex flex-col justify-center items-center space-y-2 hover:bg-white/5"
    [ngClass]="{
      'border-cyan bg-white/5': isDraggedOver,
      'border-white/50': !isDraggedOver && !compactMode,
      'border-white/20': !isDraggedOver && compactMode
    }"
  >
    <input
      #fileDropInput
      id="fileDropInput"
      class="absolute top-0 left-0 z-10 w-full h-full opacity-0 hover:cursor-pointer"
      type="file"
      [multiple]="isMultipleUploadEnabled"
      [accept]="acceptableMimeTypes ? (acceptableMimeTypes | join: ',') : null"
      (change)="handleFiles($event)"
    >

    <nrc-icon class="w-32 h-20" [name]="'file-drop'" />

    <span class="text-base font-normal text-white">
      {{ 'COMPONENTS.FILE_UPLOADER.DRAG_AND_DROP' | translate }}
    </span>

    <label class="text-sm font-light text-white/50" for="fileDropInput">
      {{ 'COMPONENTS.FILE_UPLOADER.SELECT_A_FILE' | translate }}
    </label>
  </div>

  <div #fileListContainer class="flex flex-col w-full space-y-1 overflow-auto max-h-52">
    @for (fileListItem of fileList; let i = $index; track i) {
      <div #fileListItems class="flex items-center justify-between w-full p-3 space-x-3 rounded grow bg-white/5">
        <nrc-icon class="w-7 h-7 opacity-30" [name]="'image'" />

        <div class="flex flex-col space-y-2 grow">
          <div class="flex items-center justify-between overflow-hidden">
            <span class="text-sm font-light text-white break-all">
              {{ fileListItem.file.name }}
            </span>

            @switch (fileListItem.status()) {
              @case ('in-progress') {
                <span class="text-sm font-light text-white">
                  {{ fileListItem.progress() }}&percnt;
                </span>
              }
              @case ('success') {
                <div class="flex items-center justify-end space-x-2">
                  <nrc-icon class="w-3 h-3" [name]="'check'" [fillColor]="'success'" />

                  <span class="text-sm font-light text-white text-end">
                    {{ 'COMPONENTS.FILE_UPLOADER.UPLOAD_STATUS.SUCCESS' | translate }}
                  </span>
                </div>
              }
              @case ('failed') {
                <div class="flex items-center justify-end space-x-2">
                  <nrc-icon class="w-3 h-3 rotate-45" [name]="'plus'" [fillColor]="'error'" />

                  <span class="text-sm font-light text-white text-end">
                      {{ fileListItem.error() || 'COMPONENTS.FILE_UPLOADER.UPLOAD_STATUS.FAILED' | translate }}
                  </span>
                </div>
              }
            }
          </div>

          <nrc-progress-bar class="w-full" [progress]="fileListItem.progress()" />
        </div>

        <div class="flex items-center justify-end ml-4 mr-2 space-x-2">
          @if (fileListItem.status() === 'in-progress') {
            <nrc-loading-spinner />
          } @else {
            <button class="w-4 h-4 rotate-45 opacity-75 hover:opacity-100" (click)="removeFileFromList(i)">
              <nrc-icon [name]="'plus'" />
            </button>
          }
        </div>
      </div>
    }
  </div>
</div>
